
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/social-media-marketing",
      function () {
        return require("private-next-pages/social-media-marketing/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/social-media-marketing"])
      });
    }
  